var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-input-group',{staticClass:"mb-3",attrs:{"prepend":"Filter by client"}},[_c('b-form-select',{attrs:{"options":_vm.FilterCouncils()},on:{"input":_vm.handleInput},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }